import styled from 'styled-components';

export const FormBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const TypeCardRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

export const TypeCard = styled.div<{ $selected: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme, $selected }) => ($selected ? theme.palette.info.main : theme.palette.divider)};
  background: ${({ theme, $selected }) => ($selected ? theme.tint.primary.subtle : theme.palette.common.white)};
`;

export const TypeCardTop = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TypeRadioDot = styled.span<{ $selected: boolean }>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid ${({ theme, $selected }) => ($selected ? theme.palette.info.main : theme.palette.grey[400])};
  position: relative;
  flex-shrink: 0;

  &::after {
    content: '';
    position: absolute;
    inset: 2px;
    border-radius: 50%;
    background: ${({ theme, $selected }) => ($selected ? theme.palette.info.main : 'transparent')};
  }
`;

export const TypeCardTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const TypeCardDesc = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;
